export default __webpack_public_path__ + "static/media/ja.1ca5a40c.svg";